import './SideBar.css';
import { NavLink } from 'react-router-dom';

export default function SideBar({isMobile}) {

  return (
    <div className={`SideBar ${(isMobile) ? 'collapsed':''}`}>
        
        <div className={`middleSection ${(isMobile) ? 'collapsed':''}`}>
            <div className='navLinks'>
                <NavLink to='/intakeForms' className='navLink'>
                    <button id='forms'>
                        <svg width="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M11.6668 1.66663H5.00016C4.55814 1.66663 4.13421 1.84222 3.82165 2.15478C3.50909 2.46734 3.3335 2.89127 3.3335 3.33329V16.6666C3.3335 17.1087 3.50909 17.5326 3.82165 17.8451C4.13421 18.1577 4.55814 18.3333 5.00016 18.3333H15.0002C15.4422 18.3333 15.8661 18.1577 16.1787 17.8451C16.4912 17.5326 16.6668 17.1087 16.6668 16.6666V6.66663L11.6668 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M11.6665 1.66663V6.66663H16.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.3332 10.8334H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M13.3332 14.1666H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.33317 7.5H7.49984H6.6665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (!isMobile) &&
                        <span className='buttonText'>
                            Intake Forms
                        </span>
                        }
                    </button>
                </NavLink>
                <NavLink to='/projects' className='navLink'>
                    <button id='projects'>
                        <svg width="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M8.75 2.625H2.625V8.75H8.75V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 2.625H12.25V8.75H18.375V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M18.375 12.25H12.25V18.375H18.375V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M8.75 12.25H2.625V18.375H8.75V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        { (!isMobile) &&
                        <span className='buttonText'>
                            Projects
                        </span>
                        }
                    </button>
                </NavLink>
                <NavLink to='/patents' className='navLink'>
                    <button id='patents'>
                        <svg width="21" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                        </svg>
                        { (!isMobile) &&
                        <span className='buttonText'>
                            Patents
                        </span>
                        }
                    </button>
                </NavLink>
                <NavLink to='/trademarks' className='navLink'>
                    <button id='trademarks'>
                        <svg width="21" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                            <rect x="1.47275" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 1.47275 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                            <rect x="8.57383" y="17.1" width="16.2" height="6.48374" rx="3.24187" transform="rotate(-90 8.57383 17.1)" stroke="currentColor" strokeWidth="1.2"/>
                        </svg>
                        { (!isMobile) &&
                        <span className='buttonText'>
                            Trademarks
                        </span>
                        }
                    </button>
                </NavLink>
            </div>
        </div>
    </div>
  )
}
